/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types */
import {
  Component,
} from '@angular/core';

import {
  Router
} from '@angular/router';


@Component({
  standalone: false,
  selector: 'app-root',
  template: `<alert style="margin-bottom: 0;"></alert><router-outlet></router-outlet>`
})

export class AppComponent {

  private title: string   = 'rail-viewer';

  constructor(
    private router: Router
  ) {

  }

}
